import theme from './tailwindTheme';
import { useMediaQuery } from './useMediaQuery';

/**
 * A hook indicating whether the current screen width is at least the **desktop** breakpoint defined in the theme.
 * @returns True if the screen width is at least the **desktop** breakpoint, false otherwise.
 */
export function useIsDesktopScreen(defaultValue = true) {
  return useMediaQuery(`(min-width: ${(theme.screens as Record<string, string>).desktop})`, defaultValue);
}

export function useIsMobileScreen(defaultValue = false) {
  return useMediaQuery(`(max-width: ${(theme.screens as Record<string, string>).mobile})`, defaultValue);
}

export function useIsTabletScreen(defaultValue = false) {
  return useMediaQuery(`(max-width: ${(theme.screens as Record<string, string>).tablet})`, defaultValue);
}
